








import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Templates/Header.vue';

@Component({
  components: {
    'header-component': Header,
  },
})
export default class App extends Vue {}
